/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import PhotoUpload from "../PhotoUpload";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { fetchTeams } from "../fetchData";

const SelectTeamData = ({
  toast,
  isUploadInProgress,
  setIsUploadInProgress,
  fileValues,
  setFileValues,
  timeStampLocationValues,
  setTimeStampLocationValues,
  formValues,
  setFormValues,
  selectedTeam,
  setSelectedTeam,
  selectedTeamMember1,
  setSelectedTeamMember1,
  selectedTeamMember2,
  setSelectedTeamMember2,
  additionalTeamMember,
  setAdditionalTeamMember,
  images1,
  setImages1,
  images2,
  setImages2,
  images3,
  setImages3,
}: any) => {
  const [teamsList, setTeamsList] = useState<any>([]);
  const [teamsListLoading, setTeamsListLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchTeams(setTeamsList, setTeamsListLoading, toast);
  }, [formValues?.date]);

  useEffect(() => {
    if (selectedTeam) {
      setFileValues([]);
      setTimeStampLocationValues({
        locations: [],
        timeStamps: [],
      });
      setImages1({});
      setImages2({});
      setImages3({});
      setSelectedTeamMember1(null);
      setSelectedTeamMember2(null);
      setAdditionalTeamMember([]);

      setFormValues((prev: any) => ({
        ...prev,
        teamMember1: {
          userID: null,
          displayName: null,
          photo: null,
          signature: null,
          signatureDate: null,
        },
        teamMember2: {
          userID: null,
          displayName: null,
          photo: null,
          signature: null,
          signatureDate: null,
        },
        additionalTeamMembers: [],
        dma_location: null,
        vehicleRegistration: null,
        keyPlantDetails: null,
        activity: null,
        emergencyDetails: {
          aAndE: null,
          emergencyContact: null,
          isFirstAiderAvailable: null,
          isFirstAidKitAvailable: null,
        },
        startWorkAssessment: {
          checklist: [
            {
              label:
                "Have all team members read, understood and agreed on the risk assessment and method statement.    ",
              value: null,
              name: "handlingEquipment",
            },
            {
              label: "Have all team membersreceived an induction?",
              value: null,
              name: "drivingAssessment",
            },
            {
              label: "Is there at least one trained NRSWA Operative on site?",
              value: null,
              name: "highwayCodeTest",
            },
            {
              label:
                "Are team members trained, have an in-date ticket and competent?",
              value: null,
              name: "vehicleSafetyTest",
            },
            {
              label:
                "Does the team have PPE as defined within Risk Assessments & Method Statements?",
              value: null,
              name: "issueOfPPE",
            },
          ],
          riskelements: [
            { label: "Lone Working ", value: null, name: "loneWorking" },
            {
              label: "Pedestrians/Public Access/Egress",
              value: null,
              name: "pedestrianPublicEgress",
            },
            {
              label: "COSHH Materials (i.e. chlorus, cement) ",
              value: null,
              name: "coshhMaterials",
            },
            { label: "Night Working", value: null, name: "nightWorking" },
            {
              label: "Environmental (i.e. dust, waste, spillage)",
              value: null,
              name: "environmental",
            },
            {
              label: "Tool & Equipment ",
              value: null,
              name: "toolAndEquipment",
            },
            {
              label:
                "Underfoot Hazards(i.e. wet,sloping ground, footpath boards)",
              value: null,
              name: "underfootHazards",
            },
            {
              label: "Traffic Management",
              value: null,
              name: "trafficManagement",
            },
          ],
        },
        additionalComments: null,
        confirmSiteSafety: {
          label:
            "Please Confirm That the site & key plant is safe, and works can proceed safely. ",
          value: null,
          name: "confirmSafety",
          areaManager: null,
        },
      }));
    }
  }, [selectedTeam]);

  const cleanupUserData = (userId: string, type?: string) => {
    if (!userId) return;

    if (type === "teamMember1") {
      setImages1({});
    } else if (type === "teamMember2") {
      setImages2({});
    }
    // Clean up photos
    if (images1[userId]) {
      const newImages1 = { ...images1 };
      delete newImages1[userId];
      setImages1(newImages1);
    }
    if (images2[userId]) {
      const newImages2 = { ...images2 };
      delete newImages2[userId];
      setImages2(newImages2);
    }
    if (images3[userId]) {
      const newImages3 = { ...images3 };
      delete newImages3[userId];
      setImages3(newImages3);
    }

    // Clean up file values
    setFileValues((prev: any[]) =>
      prev.filter((item) => item.userID !== userId)
    );

    // Clean up location and timestamp data
    setTimeStampLocationValues((prev: any) => ({
      locations: prev.locations.filter((loc: any) => loc.userID !== userId),
      timeStamps: prev.timeStamps.filter((ts: any) => ts.userID !== userId),
    }));
  };

  const handleTeamMember1Change = (e: any) => {
    // Clean up previous team member's data if it exists
    if (selectedTeamMember1?.userID) {
      cleanupUserData(selectedTeamMember1.userID, "teamMember1");
    }

    setFormValues((prev: any) => ({
      ...prev,
      teamMember1: {
        ...prev.teamMember1,
        userID: e.value.userID,
        displayName: e.value.displayName,
        photo: null,
      },
    }));
    setSelectedTeamMember1(e.value);
  };

  const handleTeamMember2Change = (e: any) => {
    // Clean up previous team member's data if it exists
    if (selectedTeamMember2?.userID) {
      cleanupUserData(selectedTeamMember2.userID, "teamMember2");
    }

    setFormValues((prev: any) => ({
      ...prev,
      teamMember2: {
        ...prev.teamMember2,
        userID: e.value.userID,
        displayName: e.value.displayName,
        photo: null,
      },
    }));
    setSelectedTeamMember2(e.value);
  };

  const handleAdditionalTeamMembersChange = (e: any) => {
    // Find removed members
    const removedMembers = additionalTeamMember.filter(
      (prevMember: any) =>
        !e.value.some((current: any) => current.userID === prevMember.userID)
    );

    // Clean up data for removed members
    removedMembers.forEach((member: any) => {
      cleanupUserData(member.userID);
    });

    setFormValues((prev: any) => ({
      ...prev,
      additionalTeamMembers: e.value.map((member: any) => ({
        ...member,
        photo: null,
      })),
    }));
    setAdditionalTeamMember(e.value);
  };

  return (
    <div>
      <div className="tw-flex tw-flex-col tw-gap-2">
        <label className="leak-label" htmlFor="teamname">
          Work Area
        </label>
        <Dropdown
          id="teamMember1"
          optionLabel="teamName"
          placeholder="Select Work Area"
          value={selectedTeam}
          loading={teamsListLoading}
          disabled={isUploadInProgress}
          onChange={(e) => {
            setFormValues((prev: any) => ({
              ...prev,
              teamName: e.value.teamName,
              teamID: e.value.teamID,
            }));
            setSelectedTeam(e.value);
          }}
          options={teamsList}
          filter
          className="custome-dropdown"
        />
      </div>
      <div className="tw-flex tw-justify-start tw-gap-5 tw-mt-4 tw-items-start tw-flex-wrap tw-w-full">
        {/* Team Member 1 */}
        <div className="tw-flex tw-flex-col tw-gap-5 tw-w-full md:tw-w-fit">
          <div className="tw-flex tw-flex-col tw-gap-1">
            <label className="leak-label" htmlFor="teamMember1">
              Team Member 1
            </label>
            <Dropdown
              id="teamMember1"
              optionLabel="displayName"
              placeholder="Select Team Member 1"
              disabled={isUploadInProgress}
              value={selectedTeamMember1}
              onChange={handleTeamMember1Change}
              options={
                selectedTeam?.teamUsers.filter(
                  (member: any) =>
                    member.userID !== selectedTeamMember2?.userID &&
                    member.isUserAvailable &&
                    !additionalTeamMember.some(
                      (additional: any) => additional.userID === member.userID
                    )
                ) ?? []
              }
              filter
              className="custome-dropdown"
            />
          </div>
          <PhotoUpload
            label="Photo of Team Member 1 in PPE"
            images={images1}
            isUploadInProgress={isUploadInProgress}
            setIsUploadInProgress={setIsUploadInProgress}
            setImages={setImages1}
            formValues={formValues}
            setFormValues={setFormValues}
            fileValues={fileValues}
            timeStampLocationValues={timeStampLocationValues}
            setTimeStampLocationValues={setTimeStampLocationValues}
            setFileValues={setFileValues}
            classname="lg:tw-max-w-[370px]"
            maxImages={selectedTeamMember1 ? 1 : 0}
            type="teamMember1"
          />
        </div>

        {/* Team Member 2 */}
        <div className="tw-flex tw-flex-col tw-gap-5 tw-w-full md:tw-w-fit">
          <div className="tw-flex tw-flex-col tw-gap-1">
            <label className="leak-label" htmlFor="teamnMember2">
              Team Member 2
            </label>
            <Dropdown
              id="teamnMember2"
              optionLabel="displayName"
              placeholder="Select Team Member 2"
              value={selectedTeamMember2}
              disabled={isUploadInProgress}
              onChange={handleTeamMember2Change}
              options={
                selectedTeam?.teamUsers.filter(
                  (member: any) =>
                    member.userID !== selectedTeamMember1?.userID &&
                    member.isUserAvailable &&
                    !additionalTeamMember.some(
                      (additional: any) => additional.userID === member.userID
                    )
                ) ?? []
              }
              filter
              className="custome-dropdown"
            />
          </div>
          <PhotoUpload
            label="Photo of Team Member 2 in PPE"
            images={images2}
            isUploadInProgress={isUploadInProgress}
            setIsUploadInProgress={setIsUploadInProgress}
            setImages={setImages2}
            formValues={formValues}
            setFormValues={setFormValues}
            fileValues={fileValues}
            timeStampLocationValues={timeStampLocationValues}
            setTimeStampLocationValues={setTimeStampLocationValues}
            setFileValues={setFileValues}
            classname="lg:tw-max-w-[370px]"
            maxImages={selectedTeamMember2 ? 1 : 0}
            type="teamMember2"
          />
        </div>

        {/* Additional Team Members */}
        <div className="tw-flex tw-flex-col tw-gap-5 lg:tw-w-lg tw-w-full md:tw-w-fit">
          <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full">
            <label className="leak-label" htmlFor="addteamname">
              Additional Team Member If Any
            </label>
            <MultiSelect
              id="addteamname"
              optionLabel="displayName"
              maxSelectedLabels={2}
              disabled={isUploadInProgress}
              selectAllLabel="Select All"
              placeholder="Select Additional Member"
              value={additionalTeamMember}
              onChange={handleAdditionalTeamMembersChange}
              options={
                selectedTeam?.teamUsers.filter(
                  (member: any) =>
                    member.userID !== selectedTeamMember1?.userID &&
                    member.isUserAvailable &&
                    member.userID !== selectedTeamMember2?.userID
                ) ?? []
              }
              filter
              className="custome-multiselect"
            />
          </div>
          <PhotoUpload
            label="Photo of any additional team member in PPE"
            images={images3}
            isUploadInProgress={isUploadInProgress}
            setIsUploadInProgress={setIsUploadInProgress}
            setImages={setImages3}
            formValues={formValues}
            setFormValues={setFormValues}
            timeStampLocationValues={timeStampLocationValues}
            setTimeStampLocationValues={setTimeStampLocationValues}
            fileValues={fileValues}
            setFileValues={setFileValues}
            classname="tw-w-full"
            maxImages={
              additionalTeamMember?.length > 0 ? additionalTeamMember.length : 0
            }
            type="additionalTeamMember"
          />
        </div>
      </div>
    </div>
  );
};

export default SelectTeamData;
